const PASSTHROUGH_PARAMS: string[] = [
  "vouch_product",
  "room_number",
  "page_location",
  "page_referrer",
  "page_location_content_id",
  "page_referrer_content_id",
  "engagement_time_msec",
  "service_gtm_id",
  "service_name",
  "content_id",
  "content_code",
  "content_name",
  "content_policy",
  "content_button_title",
  "content_button_url",
  "content_location",
  "content_maps_url",
  "content_url",
  "promotion_id",
  "promotion_code",
  "promotion_title",
  "promotion_type",
  "language_code",
  "language_name",
];

export interface MappedDataLayerEvent {
  name: string;
  params: Record<string, unknown>;
}

export function mapDataLayerPayload(
  payload: unknown,
): MappedDataLayerEvent | null {
  if (!payload || typeof payload !== "object") return null;
  const record = payload as Record<string, unknown>;
  const name = String(record.event || record.event_name || "");
  if (!name) return null;
  const params: Record<string, unknown> = {};
  for (const key of PASSTHROUGH_PARAMS) {
    if (record[key] !== undefined) params[key] = record[key];
  }
  return { name, params };
}

/**
 * Bridge every `window.dataLayer.push(...)` call into the first-party tracker so
 * existing push sites do not each need editing. Idempotent.
 */
export function installDataLayerBridge(
  onEvent: (event: MappedDataLayerEvent) => void,
): void {
  if (typeof window === "undefined") return;
  const target = window as unknown as {
    dataLayer?: Array<Record<string, unknown>> & { __gepBridged?: boolean };
  };
  const dataLayer = (target.dataLayer = target.dataLayer || []);
  if (dataLayer.__gepBridged) return;
  dataLayer.__gepBridged = true;
  const originalPush = dataLayer.push.bind(dataLayer);
  dataLayer.push = (...args: Array<Record<string, unknown>>) => {
    for (const arg of args) {
      try {
        const mapped = mapDataLayerPayload(arg);
        if (mapped) onEvent(mapped);
      } catch {
        // Tracking must never block the original dataLayer consumer, so a
        // tracker failure cannot prevent the original push below.
      }
    }
    return originalPush(...args);
  };
}
